// src/hooks/useSnackbarCustom.js

import { useSnackbar } from "notistack";

const useSnackbarCustom = () => {
  const snackbar = useSnackbar();
  return snackbar;
};

export default useSnackbarCustom;
